import React, { useEffect, useState } from "react";

import { Button, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import headerMenu from "../../../Json/HeaderMenu.list.json";
import useStyles from "../Header.styles";
import {
  logoutStart,
  thirdPartyTokenLoginStart
} from "../../../redux-saga/redux/auth/authentication";
import { agentBetcoinTokenRoles } from "../../../utils/constants";

const Dropdown = ({ isLoggedIn }) => {
  const { agentDetails, userDetails, walletAmount } = useSelector(
    (state) => state.myProfile
  );
  const { thirdPartyRedirectUrl } = useSelector(
    (state) => state.authentication
  );
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [anchorElAccount, setAnchorElAccount] = useState(null);
  const openAccount = Boolean(anchorElAccount);

  const handleOpenAccount = (event) => {
    setAnchorElAccount(event.currentTarget);
  };

  const handleCloseAccount = () => {
    setAnchorElAccount(null);
  };

  const handleLogout = () => {
    setAnchorElAccount(null);
    dispatch(logoutStart());
  };

  const betCoinTokenPermission =
    agentDetails?.roles?.filter((rolesData) => {
      return agentBetcoinTokenRoles?.find((abbr) => rolesData?.abbr === abbr);
    })?.length === agentBetcoinTokenRoles?.length;

  useEffect(() => {
    if (thirdPartyRedirectUrl) {
      window.location.href = thirdPartyRedirectUrl;
    }
  }, [thirdPartyRedirectUrl]);

  const thirdpartyHandler = () => {
    if (betCoinTokenPermission) {
      dispatch(thirdPartyTokenLoginStart());
    }
  };

  return (
    <>
      <Button
        id="account-button"
        className={`${classes.btnPrimary} ${classes.accountBtn}`}
        aria-controls={openAccount ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openAccount ? "true" : undefined}
        onClick={handleOpenAccount}
        startIcon={<img src="/images/AccountVector.svg" alt="Account Icon" />}
      >
        {!isMobile && t("HEADER.ACCOUNT")}
      </Button>
      <Menu
        id="account-menu"
        anchorEl={anchorElAccount}
        open={openAccount}
        className={classes.accountMenu}
        onClose={handleCloseAccount}
        MenuListProps={{
          "aria-labelledby": "account-button"
        }}
      >
        {betCoinTokenPermission && (
          <>
            <Grid className={classes.menuHeaderWrap}>
              <Typography>
                {userDetails.userName || userDetails.nickName}
              </Typography>
              <Grid className={classes.walletWrapper}>
                <img
                  width="16"
                  height="16"
                  src="/images/coin.webp"
                  alt="Coin Icon"
                />
                <span> {walletAmount}</span>
              </Grid>
            </Grid>
            <Grid className={classes.redirectBtnWrapper}>
              <Button
                onClick={thirdpartyHandler}
                className={classes.withDrawButton}
              >
                {t("HEADER.WITHDRAW")}
              </Button>
              <Button
                onClick={thirdpartyHandler}
                className={classes.depositeButton}
              >
                {t("HEADER.DEPOSIT")}
              </Button>
            </Grid>
          </>
        )}

        {headerMenu.map((item) => {
          if (!isLoggedIn && item.to === "/user/resetPassword") {
            return null;
          }
          if (!userDetails?.canWithdraw && item.to === "/user/withdraw") {
            return null;
          }
          return (
            <Link key={item.to} className={classes.myAccountLink} to={item.to}>
              <MenuItem key={item.to} onClick={handleCloseAccount}>
                <span>
                  <img src={item.src} alt={item.alt} />
                </span>
                {t(item.content)}
              </MenuItem>
            </Link>
          );
        })}
        {betCoinTokenPermission && (
          <MenuItem onClick={thirdpartyHandler}>
            <span className={classes.plusMinusIcon}>+/-</span>
            {t("HEADER.DEPOSITE/WITHDRAW")}
          </MenuItem>
        )}
        <MenuItem onClick={handleLogout}>
          <span>
            {" "}
            <img src="/images/logout.svg" alt="logout Icon" />{" "}
          </span>
          {t("HEADER.LOG_OUT")}
        </MenuItem>
      </Menu>
    </>
  );
};
// {
//   "content": "HEADER.DEPOSIT",
//   "to": "/user/deposit",
//   "src": "/images/deposit.svg",
//   "alt": "Deposit Icon"
// },
// {
//   "content": "HEADER.WITHDRAW",
//   "to": "/user/withdraw",
//   "src": "/images/withdrawal.svg",
//   "alt": "Withdrawal Icon"
// },
export default Dropdown;
